import React from 'react';
import { Gift, Calendar, Award } from 'lucide-react';
import { motion } from 'framer-motion';

const DRAWS = [
  {
    id: 'weekly',
    title: 'Haftalik Buyuk Cekilis',
    desc: 'Her hafta bir sans, buyuk oduller sizleri bekliyor.',
    icon: Gift,
    date: 'Her Cuma',
    prize: 'Ozel Bonuslar'
  },
  {
    id: 'monthly',
    title: 'Aylik VIP Cekilis',
    desc: 'VIP uyelere ozel aylik cekilis firsatlari.',
    icon: Award,
    date: 'Her Ayin Sonu',
    prize: 'VIP Oduller'
  },
  {
    id: 'special',
    title: 'Ozel Etkinlikler',
    desc: 'Sponsorlarimizin duzenledigi ozel etkinlik ve kampanyalar.',
    icon: Calendar,
    date: 'Degisen Tarihler',
    prize: 'Cesitli'
  }
];

const Draws = () => {
  return (
    <div style={{ padding: '3rem 0' }}>
      <div className="page-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="section-title" style={{ fontSize: '2rem' }} data-testid="cekilisler-page-title">Cekilisler</h1>
          <p className="section-subtitle">Kampanyalar ve ozel etkinlikler</p>
        </motion.div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '1.25rem'
        }}>
          {DRAWS.map((draw, idx) => {
            const Icon = draw.icon;
            return (
              <motion.div
                key={draw.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.1 }}
                viewport={{ once: true }}
              >
                <div className="sponsor-card" style={{ padding: '2rem' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    marginBottom: '1rem'
                  }}>
                    <div style={{
                      width: 48,
                      height: 48,
                      borderRadius: '50%',
                      background: 'rgba(0,194,255,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Icon size={22} style={{ color: 'hsl(200, 96%, 60%)' }} />
                    </div>
                    <div>
                      <h3 className="sponsor-card-name" style={{ marginBottom: '0.15rem' }}>{draw.title}</h3>
                      <span style={{ fontSize: '0.75rem', color: 'hsl(215, 12%, 70%)' }}>{draw.date}</span>
                    </div>
                  </div>
                  <p className="sponsor-card-desc">{draw.desc}</p>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <span className="sponsor-card-badge">{draw.prize}</span>
                    <span className="sponsor-card-badge" style={{ background: 'rgba(249,248,113,0.12)', color: 'hsl(59, 94%, 71%)', borderColor: 'rgba(249,248,113,0.25)' }}>Yakinda</span>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Draws;
